import React, { Fragment, useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import {
  FormColumn,
  FormRowGroup,
} from 'modules/tickets/components/common/dialog/TicketFormUtils';
import InlineAlert from 'app/commonComponents/InlineAlert';
import {
  Title,
  SubTitle,
  DetailsBox,
  Row,
  Divider,
  DateSpan,
  MutedText,
  RefundRow,
  RefundLeft,
} from './styles/WithdrawalStyles';
import { VoucherDetailsRows } from './WithdrawalDetailsShared';
import form from 'modules/ticketPublicPage/stores/vouchers/form';
import { PAYMENT_TYPES } from 'app/constants';
import facility from 'app/facility';

const WithdrawalFinal = observer(() => {
  const { formValues, serverError } = form;
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = window.setInterval(() => {
      setNow(new Date());
    }, 1000); // keep time display accurate

    return () => {
      window.clearInterval(timer);
    };
  }, []);

  const {
    ref_num: refNum,
    buyer_name: buyerName,
    email,
    created,
    amount,
    amount_left: amountLeft,
    currency,
    claims,
    payment,
  } = formValues.get('withdrawal_voucher_purchase') || {};

  const { paymentType } = payment || {};

  const paymentTypeLabel =
    PAYMENT_TYPES[paymentType] || i18n.gettext('Unknown');
  const withdrawalReason = formValues.get('withdrawal_reason');

  return (
    <FormRowGroup style={{ width: '100%' }}>
      <FormColumn style={{ width: '100%' }}>
        <Title>{i18n.gettext('Data confirmation')}</Title>
        <SubTitle>
          {i18n.gettext(
            'I hereby cancel my contract for the purchase of the voucher:'
          )}
        </SubTitle>

        <DetailsBox>
          <VoucherDetailsRows
            refNum={refNum}
            buyerName={buyerName}
            email={email}
            created={created}
            amount={amount}
            currency={currency}
            claims={claims}
          />

          <Divider />

          <RefundRow>
            <RefundLeft>
              <MutedText>{i18n.gettext('Refund')}</MutedText>
              <DateSpan>{moment(now).format('L, HH:mm')}</DateSpan>
            </RefundLeft>
            <span style={{ fontWeight: 600, alignSelf: 'center' }}>
              {facility.getFormattedPrice(amountLeft, currency)}
            </span>
          </RefundRow>

          <Row>
            <span>{i18n.gettext('Payment')}</span>
            <span>{paymentTypeLabel}</span>
          </Row>
          {!withdrawalReason ? (
            <Row>
              <span>{i18n.gettext('Reason')}</span>
              <span>-</span>
            </Row>
          ) : (
            <Fragment>
              <Row>
                <span>{i18n.gettext('Reason')}</span>
              </Row>
              <div style={{ marginTop: '-0.5rem', fontSize: '0.8rem' }}>
                {withdrawalReason}
              </div>
            </Fragment>
          )}
        </DetailsBox>

        {serverError && typeof serverError === 'string' ? (
          <InlineAlert
            type="error"
            style={{ marginTop: '1rem', fontSize: '0.9rem' }}
          >
            <span>{serverError}</span>
          </InlineAlert>
        ) : null}
      </FormColumn>
    </FormRowGroup>
  );
});

export default WithdrawalFinal;
